import React, { useContext, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Divider,
} from "@mui/material";
import {
  AccountCircle as AccountCircleIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import ConfirmationDialog from "../components/ConfirmationDialog";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLogoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
    handleMenuClose();
  };

  const handleLogoutConfirm = () => {
    logout(); // Call the logout function from AuthContext
    window.location.href = "/"; // Redirect to home after logout
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          bgcolor: "secondary.main",
          color: "white",
          height: "60px",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          {/* Logo / Title */}
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontWeight: "bold",
              fontFamily: "Comfortaa",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            EventPass
          </Typography>

          {/* User Account Section */}
          <Box>
            {user ? (
              <>
                {/* Account Icon as a Button */}
                <IconButton
                  onClick={handleMenuOpen}
                  color="inherit"
                  sx={{ marginLeft: 1, mb: { sm: "10px" } }}
                >
                  <AccountCircleIcon fontSize="large" />
                </IconButton>

                {/* Dropdown Menu */}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <MenuItem disabled>
                    <AccountCircleIcon
                      fontSize="small"
                      sx={{ marginRight: 1, color: "primary.main" }}
                    />
                    {user.username}
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogoutClick}>
                    <LogoutIcon
                      fontSize="small"
                      sx={{ marginRight: 1, color: "error.main" }}
                    />
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                color="inherit"
                component={Link}
                to="/login"
                sx={{
                  textTransform: "none",
                  mx: 1,
                  fontWeight: "bold",
                }}
                startIcon={<LoginIcon />}
              >
                Sign in
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Logout Confirmation Dialog */}
      <ConfirmationDialog
        open={isLogoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        title="Logout Confirmation"
        message="Are you sure you want to log out?"
        onConfirm={handleLogoutConfirm}
        confirmButtonText="Logout"
      />
    </>
  );
};

export default Navbar;
